/**
 * Represents a word in the word cloud with its position and size.
 * @class
 */
export default class Word {
	/**
	 * @type {{x: number, y: number}} position - The x and y coordinates of the word.
	 */
	position = { x: 0, y: 0 };

	/**
	 * @type {HTMLElement} element - The HTML element representing the word.
	 */
	element;

	/**
	 * @type {{width: number, height: number}} size - The width and height of the word element.
	 */
	size = { width: 0, height: 0 };

	/**
	 * @type {{x: number, y: number}} startPosition - The initial position of the word.
	 */
	startPosition = { x: 0, y: 0 };

	/**
	 * @type {{vx: number, vy: number}} velocity - The velocity of the word in x and y directions.
	 */
	velocity = { vx: 0, vy: 0 };

	/**
	 *
	 * @param {HTMLElement} element - The HTML element representing the word.
	 * @constructor
	 */
	constructor(element) {
		this.element = element;
		this.size.width = this.element.offsetWidth;
		this.size.height = this.element.offsetHeight;
	}

	/**
	 * Sets the position of the word.
	 * @param {number} x - The x coordinate to set.
	 * @param {number} y - The y coordinate to set.
	 * @return {void}
	 */
	setPosition(x, y) {
		this.position.x = x;
		this.position.y = y;
	}

	/**
	 *
	 * @param {number} x
	 * @param {number} y
	 */
	setStartPosition(x, y) {
		this.startPosition.x = x;
		this.startPosition.y = y;
	}
}
